export default "__VITE_ASSET__CnBl1BWm__"